import { ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PaperCreditService } from './paper-credit.service';
import { FormErrorHandler } from '@app/shared/form-error-handler';
import { of } from 'rxjs';
import { DealerInfoModel } from '../dealer-info/dealer-info.model';
import { DealerInfoService } from '../dealer-info/dealer-info.service';
import { MarketType } from '@app/domain/model/market-type';
import { ReportType } from '@app/domain/model/report-type';
import { ApprovalStatus } from '@app/domain/model/approval-status';
import { inRange, positiveNumber } from '@app/shared/validators/purchase.validator';
import Big from 'big.js';
import { PaperCreditModel } from './paper-credit.model';
import { ReportingPeriod } from '@app/feature/dealer/report/reporting-period';
import { DealerProfile } from '@app/domain/model/dealer-profile';
import { validateDate } from '@app/shared/validators/date.validator';
import { DatePickerFormatter } from '@app/util/date-picker-formatter';

@Component({
  providers: [{ provide: NgbDateParserFormatter, useClass: DatePickerFormatter }],
  selector: 'app-paper-credit',
  templateUrl: './paper-credit.component.html',
  styleUrls: ['./paper-credit.component.scss']
})
export class PaperCreditComponent implements OnInit {


  @Input()
  period: ReportingPeriod;
  @Input()
  dealer: DealerProfile;

  // make the enums' values accessible from template
  MarketType: typeof MarketType = MarketType;
  ReportType: typeof ReportType = ReportType;
  marketTypes: Set<MarketType> = new Set<MarketType>();

  // report form
  reportForm: FormGroup;
  loading = false;
  showCancelWarning: boolean;
  paperCredit: PaperCreditModel;

  dealerAutocompleteFormatter = (dealerInfo: DealerInfoModel) => {
    return dealerInfo ? `${dealerInfo.licenseNumber} (${dealerInfo.businessName})` : null;
  }
  dealerAutocompleteInputFormatter = (dealerInfo: DealerInfoModel) => {
    return dealerInfo ? dealerInfo.licenseNumber.toString() : null;
  }
  dealerAutocomplete = (term: string) => {
    if (term.length < 3) {
      return of([]);
    }

    return this.dealerInfoService.getDealers(term);
  }

  constructor(private dealerInfoService: DealerInfoService,
              private activeModal: NgbActiveModal,
              readonly formErrorHandler: FormErrorHandler,
              private readonly formBuilder: FormBuilder,
              private readonly paperCreditService: PaperCreditService) { }

  ngOnInit() {
    this.initForm();

    if(this.dealer){
      this.reportForm.patchValue({
        dealer: this.dealer.id,
        dealerName: this.dealer.businessName
      });
      this.marketTypes = this.dealer.marketTypes;
      this.reportForm.get('dealer').markAsTouched();

    }

  }
  private initForm() {

    const formFields = {
      dealer: ['', Validators.required],
      dealerName: [''],
      reportType: ['', Validators.required],
      reportDate: ['', [Validators.required, validateDate]],
      receivedDate: ['', [Validators.required, validateDate]]

    };

    this.reportForm = this.formBuilder.group(formFields);
  }
  onCancel() {
    if (this.showCancelWarning) {
      this.activeModal.close(false);
    }
    this.showCancelWarning = true;
  }

  onSubmit(){
    if (this.reportForm.invalid) {
      return;
    }
    this.submitPaperReport();
  }

  private submitPaperReport() {
    this.paperCredit = this.getReport();
    this.loading = true;
    this.paperCreditService.addPaperCredit(this.paperCredit)
      .subscribe(() => {
        this.activeModal.close(true);
        this.loading = false;
      } );
  }


  private getReport(): PaperCreditModel {
    const dealer = this.reportForm.get('dealer').value;
    const quickReports = this.reportForm.get('quickReports') as FormArray;

    const report = Object.assign({}, this.reportForm.value,
      {
        dealerId: dealer instanceof Object ? dealer.licenseNumber : dealer,
        dealerName: this.reportForm.get('dealerName').value,
        reportDate: this.reportForm.controls['reportDate'].value,
        receivedDate: this.reportForm.controls['receivedDate'].value,
        reportType: this.reportForm.get('reportType').value
      });
    return report;
  }

  onDealerSelect(dealerInfo: DealerInfoModel) {
    this.reportForm.patchValue({
      dealer: dealerInfo,
      dealerName: dealerInfo.businessName
    });
    this.marketTypes = dealerInfo.marketTypes;
  }

  onDealerEnter(dealerInfo: DealerInfoModel) {
    if(!dealerInfo){
      this.reportForm.patchValue({
        dealer: null,
        dealerName: ''
      });
      this.marketTypes.clear();
    }
    this.reportForm.get('dealer').markAsTouched();
  }


  moveToNextOnEnter(event: KeyboardEvent, id: string) {
    if (event.key === 'Enter') {
      event.preventDefault();
      const inputEl: HTMLElement = document.getElementById(id);
      if (inputEl) {
        inputEl.focus();
      }
      return false;
    }
  }



}
